import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-direction"]
const _hoisted_2 = ["name", "id", "autocomplete", "autofocus", "placeholder", "disabled", "aria-invalid", "aria-describedby", "aria-autocomplete"]

import { useInputModel } from '@src/components/shared/form_elements/useInputModel';
import { ref } from 'vue';

interface Props {
	name: string;
	modelValue: string | number;
	autocomplete?: string;
	autofocus?: boolean;
	inputId: string;
	placeholder: string;
	hasMessage: boolean;
	radioChecked: boolean;
	hasError?: boolean;
	disabled?: boolean;
	required?: boolean;
	ariaDescribedby?: string | undefined;
	ariaAutocomplete?: 'none' | 'inline' | 'list' | 'both';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextRadioFormInput',
  props: {
    name: {},
    modelValue: {},
    autocomplete: { default: 'on' },
    autofocus: { type: Boolean },
    inputId: {},
    placeholder: {},
    hasMessage: { type: Boolean },
    radioChecked: { type: Boolean },
    hasError: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    ariaDescribedby: {},
    ariaAutocomplete: {}
  },
  emits: [ 'update:modelValue', 'focus', 'blur', 'input', 'radioClicked' ],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const customInput = ref<HTMLInputElement>( null );
const inputModel = useInputModel<string | number>( () => props.modelValue, props.modelValue, emit );

const onFocus = ( event: Event ): void => emit( 'focus', event );
const onBlur = ( event: Event ): void => emit( 'blur', event );
const onInput = ( event: Event ): void => emit( 'input', event );
const onClickRadio = () => {
	customInput.value.focus();
	emit( 'radioClicked' );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-radio",
    "data-direction": _ctx.$i18n.locale === 'de-DE' ? 'rtl' : null
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["text-radio__radio", { 'text-radio__radio--checked': __props.radioChecked }]),
      onClick: onClickRadio,
      "aria-hidden": "true"
    }, null, 2),
    _withDirectives(_createElementVNode("input", {
      name: __props.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null)),
      ref_key: "customInput",
      ref: customInput,
      class: _normalizeClass(["text-radio__text", { 'is-danger': __props.hasError }]),
      id: __props.inputId,
      type: "text",
      autocomplete: __props.autocomplete,
      autofocus: __props.autofocus,
      placeholder: __props.placeholder,
      disabled: __props.disabled ? true : null,
      "aria-invalid": __props.hasError,
      "aria-describedby": __props.ariaDescribedby,
      "aria-autocomplete": __props.ariaAutocomplete,
      onBlur: onBlur,
      onFocus: onFocus,
      onInput: onInput
    }, null, 42, _hoisted_2), [
      [_vModelText, _unref(inputModel)]
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-radio__currency" }, "€", -1))
  ], 8, _hoisted_1))
}
}

})